import { BookingInfo } from 'src/api/bookingsView';
import { ProgressState } from 'src/types';

import { BookingsState } from './types';

export const emptyBookings: BookingInfo[] = [];

export const emptyUnbookings: Record<number, ProgressState> = {};

export const initialState: BookingsState = {
  loading: false,
  bookingObjectType: undefined,
  rows: emptyBookings,
  now: null,
  token: null,
  hasMore: true,
  currentRequestId: undefined,
  unbookings: emptyUnbookings,
  employee: null,
  filtersAreOpened: false,
};
